import VueDropzone from 'vue2-dropzone'
import fdaServices from '../../../../../services/notisphere/fda'
import excelParser from '../../../../../services/excel-parser'
export default {
    components: {
        VueDropzone,
    },
    props: {
        sourcePage: {
            type: String,
            default: 'openfda-devices'
        }
    },
    data() {
        return {
            loadingInitial: true,
            dropzoneOptions: {
                url: '#',
                acceptedFiles: '.xlsx',
                maxFiles: 1,
                maxFilesize: 20,
                previewsContainer: false,
                autoProcessQueue: false,
            },
            file: null,
        }
    },
    methods: {
        forceRerender() {
            this.loadingInitial = true
            this.file = null
            this.$refs.modal.show()
            this.loadingInitial = false
        },
        onClose() {
            this.$refs.modal.hide()
        },
        addFile(file) {
            const allowedExtensions = ['xlsx']
            const fileName = file.name || ''
            const fileExtension = fileName.split('.').pop().toLowerCase()

            if (!allowedExtensions.includes(fileExtension)) {
                this._showToast('Only .xlsx files are allowed.', { variant: 'danger' })
                this.file = null
                return
            }
            this.file = file
            let formData = new FormData()
            formData.append('file', this.file)

            excelParser.getExcelHeaders(formData).then(res => {
                var checkfileformat=res.data.d.includes('_id','cfres_id', 'product_res_number', 'res_event_number', 'Removal/correction/unknown')
                if(!checkfileformat){
                    this._showToast('Please choose the correct format of the file', { variant: 'danger' })
                    this.file=null
                }
            })

        },
        async save() {
            if (!this.file) {
                this._showToast('Please select a file to upload.', { variant: 'warning' })
                return
            }
            this.loadingInitial = true
            try {
                const response = await fdaServices.uploadDeviceExcelFile(this.file, this.sourcePage)
                this._showToast('File uploaded successfully.', { variant: 'success' })
            } catch (error) {
                this._showToast('Failed to upload file. Please try again.', { variant: 'danger' })
            } finally {
                this.loadingInitial = false
            }
            this.onClose()
        }
    }
}
